export default __webpack_public_path__ + "static/media/yellow_purchase.409ac35b.svg";